import { useRouter } from 'next/router';
import { HTMLAttributes } from 'react';
import FillInBasicInformationGenerateQuote from '@/website/components/switchWithJove/fillInBasicInformationGenerateQuote/index';
import AlreadyInsuredElsewhereView from '@/website/components/switchWithJove/home/alreadyInsuredElsewhere';
import { InsuranceType, useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Container } from '@mui/material';
import clsx from 'clsx';

type CalculatePriceProps = HTMLAttributes<HTMLDivElement> & { post?: any };

const CalculatePrice = (props: CalculatePriceProps) => {
  const { className, post } = props;
  const router = useRouter();
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box component={Container} className={clsx('flex flex-col items-center', className)}>
      <Box className={clsx('flex py-6', isMobileLayout ? 'w-full flex-col space-y-6 px-4' : 'w-[1280px] flex-row space-x-5')}>
        <Box className={clsx('flex flex-col justify-center', isMobileLayout ? 'w-full' : 'flex-1')}>
          <AlreadyInsuredElsewhereView />
        </Box>
        <Box className={clsx(isMobileLayout ? 'w-full' : 'flex-1')}>
          <FillInBasicInformationGenerateQuote policyExpireDateIsRequired insuranceType={router.query.insuranceType as InsuranceType} />
        </Box>
      </Box>
    </Box>
  );
};

export default CalculatePrice;
